import { Expense } from "@quantizr-engineering/common/types/show";
import { Release, Recording, Format, Revenue } from "./Recorded";

export interface CollaboratorRow {
  name: string;
  email: string;
  split: number;
  credits: string;
}

export interface RecordingsDataRow {
  releaseName: string;
  releaseDate: string;
  locale: string;
  trackCount: number;
  totalRevenue?: number | undefined;
  totalExpenses?: number | undefined;
  netProfit?: number | undefined;
  physicalCount: number;
  streamRevenue?: number | undefined;
  syncRevenue?: number | undefined;
  physicalRevenue?: number;

  // 'children' is the reserved keyword used in the grid.
  children: (Recording | Format)[];
}

export class RecordingsDataRowAdapter {
  groupRevenuesByType(revenues: Revenue[]): { [key: string]: number } {
    return revenues.reduce((acc, revenue) => {
      acc[revenue.type] = (acc[revenue.type] || 0) + revenue.amount;
      return acc;
    }, {} as { [key: string]: number });
  }

  calculateTotalExpenses(expenses: Expense[]): number {
    return expenses.reduce(
      (total, expense) => total + expense.cost * expense.quantity,
      0
    );
  }

  toRecordingsData(releases: Release[]): RecordingsDataRow[] {
    return releases.map((release) => {
      // const allRevenues = [
      //   ...release.revenues,
      //   ...release.tracks.flatMap((track) => track.revenues),
      //   ...release.formats.flatMap((physical) => physical.revenues),
      // ];

      // const groupedRevenues = this.groupRevenuesByType(allRevenues);
      // const totalRevenue = Object.values(groupedRevenues).reduce(
      //   (a, b) => a + b,
      //   0
      // );
      const totalExpenses =
        this.calculateTotalExpenses(release?.expenses ?? []) +
        release.recordings.reduce(
          (sum, rec) => sum + this.calculateTotalExpenses(rec?.expenses ?? []),
          0
        );
      const recordingsDataRow: RecordingsDataRow = {
        releaseName: release.title,
        releaseDate: new Date(release.releaseDate).toISOString().split("T")[0],
        locale: release.locale,
        trackCount: release.recordings.length,
        // totalRevenue: totalRevenue,
        totalExpenses: totalExpenses,
        // netProfit: totalRevenue - totalExpenses,
        physicalCount: release.formats?.length || 0,
        // streamRevenue: groupedRevenues["Stream"] || 0,
        // syncRevenue: groupedRevenues["Sync"] || 0,
        // physicalRevenue: groupedRevenues["Physical"] || 0,
        children: [
          ...release.recordings.map((recording) => ({
            ...recording,
            type: "Recording",
            // streamRevenue:
            //   track.revenues.find((r) => r.type === "Stream")?.amount || 0,
            // syncRevenue:
            //   track.revenues.find((r) => r.type === "Sync")?.amount || 0,
            // physicalRevenue:
            //   track.revenues.find((r) => r.type === "Physical")?.amount || 0,
          })),
          // ...release.formats?.map((physical) => ({
          //   ...physical,
          //   // streamRevenue: 0,
          //   // syncRevenue: 0,
          //   // physicalRevenue: physical.revenues.reduce(
          //   //   (sum, r) => sum + r.amount,
          //   //   0
          //   // ),
          // })),
        ],
      };

      return recordingsDataRow;
    });
  }
}
